import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function About() {
  return <div className="About">About page!</div>;
}

export default About;
